import { VariantsFilterContext } from './context';
import { FilterActions, FilterState } from './types';
import { Dispatch, useContext } from 'react';

export const useVariantFilterState = (): [FilterState, Dispatch<FilterActions>] => useContext(VariantsFilterContext)!;
